module.exports = __webpack_public_path__ + "img/whatsapp.dba66b6e.svg";